import React from 'react';
import LoadingSpinner from './LoadingSpinner';

function LoadingScreen({ text = 'Loading...' }) {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <LoadingSpinner size="md" text={text} />
    </div>
  );
}

export default LoadingScreen;

